import { observer } from 'mobx-react-lite';
import { PropsWithChildren } from 'react';

import { PlayerLevel, User } from '@/types/models';

import styles from './Profile.module.scss';
import { Currency } from '../Currency';
import { ProfileMain } from './components';

export type ProfileProps = {
  user: User;
  nextLevel: PlayerLevel;
  badges: number;
  xpBar: number;
  showWallet?: boolean;
} & PropsWithChildren;

export const Profile = observer<ProfileProps>(
  ({ children, user, badges, xpBar, nextLevel }) => (
    <header className={styles.profile}>
      <div className={styles['profile__wrap']}>
        <ProfileMain user={user} nextLevel={nextLevel} xpBar={xpBar} />
        {children}
      </div>
      <Currency badges={badges} user={user} />
    </header>
  ),
);
